import type { ReactNode } from 'react';

import {
  Container,
  IconContainer,
  Content,
  Title,
  Subtitle,
} from './FeatureCard.styled';

export type FeatureCardProps = {
  title: string;
  subtitle: string;
  icon?: ReactNode;
  iconBgColor?: string;
};

export default function FeatureCard({
  title,
  subtitle,
  icon,
  iconBgColor,
}: FeatureCardProps) {
  return (
    <Container>
      {icon && <IconContainer $bgColor={iconBgColor}>{icon}</IconContainer>}
      <Content>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Content>
    </Container>
  );
}
